module.exports = __webpack_public_path__ + "img/ch16_23_全场欢呼.29c97d74.jpg";